import { ActionOption, TableRowAction } from "../../types"
import { getWorkkeysReplaceTerm } from "../../helpers/workkeysReplaceTerms"
import { StudentReportAction } from "./components"
import { SpecificActionComponentProps } from "./types"

export const ACTION_NAMES: TableRowAction[] = Object.values(TableRowAction)

export const ACTIONS: Partial<Record<TableRowAction, ActionOption>> = {
  [TableRowAction.view]: {
    id: TableRowAction.view,
    label: "View",
    icon: "eye"
  },
  [TableRowAction.edit]: {
    id: TableRowAction.edit,
    label: "Edit",
    icon: "pencil"
  },
  [TableRowAction.delete]: {
    id: TableRowAction.delete,
    label: "Delete",
    icon: "trash"
  },
  [TableRowAction.assignStudents]: {
    id: TableRowAction.assignStudents,
    label: `Assign ${getWorkkeysReplaceTerm("students", true)}`
  },
  [TableRowAction.resendInvite]: {
    id: TableRowAction.resendInvite,
    label: "Resend Invite"
  },
  [TableRowAction.testReview]: {
    id: TableRowAction.testReview,
    icon: "eye",
    label: "Test Review"
  },
  [TableRowAction.viewAnswersReport]: {
    id: TableRowAction.viewAnswersReport,
    icon: "eye",
    label: "View Answers Report"
  },
  [TableRowAction.viewTestReport]: {
    id: TableRowAction.testReview,
    icon: "plus-circle",
    label: "View Test Report"
  },
  [TableRowAction.viewContent]: {
    id: TableRowAction.viewContent,
    icon: "ballot",
    label: "View"
  },
  [TableRowAction.assignContent]: {
    id: TableRowAction.assignContent,
    icon: "check-to-slot",
    label: "Assign"
  },
  [TableRowAction.viewItem]: {
    id: TableRowAction.viewItem,
    icon: "square-list",
    label: "View"
  },
  [TableRowAction.viewActivityLog]: {
    id: TableRowAction.viewActivityLog,
    icon: "eye",
    label: "View"
  },
  [TableRowAction.preview]: {
    id: TableRowAction.preview,
    icon: "eye",
    label: "Preview"
  },
  [TableRowAction.questionPreview]: {
    id: TableRowAction.questionPreview,
    icon: "eye",
    label: "Question Preview",
    tooltip: "Question Preview"
  },
  [TableRowAction.addToPlan]: {
    id: TableRowAction.addToPlan,
    icon: "plus-circle",
    label: "Add to Study Plan"
  },
  [TableRowAction.start]: {
    id: TableRowAction.start,
    label: "Start"
  },
  [TableRowAction.assignLicense]: {
    id: TableRowAction.assignLicense,
    label: "Assign License"
  },
  [TableRowAction.unassignLicense]: {
    id: TableRowAction.unassignLicense,
    label: "Unassign License"
  },
  [TableRowAction.endAssignment]: {
    id: TableRowAction.endAssignment,
    label: "Close",
    icon: "lock"
  },
  [TableRowAction.assignLicensePool]: {
    id: TableRowAction.assignLicensePool,
    label: "Assign License Pool"
  },
  [TableRowAction.downloadResource]: {
    id: TableRowAction.downloadResource,
    icon: "download",
    label: "Download PDF"
  },
  [TableRowAction.studentReport]: {
    id: TableRowAction.studentReport,
    label: "Download Report",
    tooltip: "Download Report",
    icon: "download"
  }
}

export const FILTER_OPTION_NAME = {
  "teachers-usage": "teacher",
  "students-usage": "student"
}

export const SPECIFIC_TABLE_ROW_ACTIONS: Partial<
  Record<TableRowAction, React.FC<SpecificActionComponentProps>>
> = {
  [TableRowAction.studentReport]: StudentReportAction
}
